import React, { useState, useMemo } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { ArrowRight, MapPin, Maximize, ChevronLeft, ChevronRight } from 'lucide-react';

const WHATSAPP_LINK = "https://wa.me/529841585732?text=Hola%2C%20me%20interesa%20invertir%20en%20Riviera%20Maya";
const IMG = (file) => `https://realestateimexico.com/img/propiedades/${file}`;
const MXN_TO_USD = 20;

const convertPrice = (priceStr, language) => {
  if (!priceStr) return priceStr;
  if (priceStr.includes('USD')) {
    const cleaned = priceStr.replace(/[^0-9]/g, '');
    const usd = parseInt(cleaned);
    if (isNaN(usd)) return priceStr;
    const mxn = usd * MXN_TO_USD;
    return language === 'es'
      ? `$${usd.toLocaleString('en-US')} USD · $${mxn.toLocaleString('es-MX')} MXN`
      : `$${usd.toLocaleString('en-US')} USD · $${mxn.toLocaleString('es-MX')} MXN`;
  }
  const cleaned = priceStr.replace(/[^0-9.,]/g, '').replace(/,/g, '');
  const num = parseFloat(cleaned);
  if (isNaN(num)) return priceStr;
  const usd = Math.round(num / MXN_TO_USD);
  return language === 'es'
    ? `$${num.toLocaleString('es-MX')} MXN · ~$${usd.toLocaleString('en-US')} USD`
    : `$${usd.toLocaleString('en-US')} USD · $${num.toLocaleString('es-MX')} MXN`;
};

const ALL_PROPERTIES = [
  { id:'paramar-black', name:'Paramar Black', zone:'Aldea Zamá', city:'Tulum', price:'$257,894 USD', priceNote:'Hasta $379,000 USD', area:'79.67 - 145.77 m²', status:'Venta', image: IMG('1764170019_Artboard1.webp'), amenities:['Gimnasio','2 Albercas','Sky Bar','Spa'], featured:true },
  { id:'t3rra', name:'T3RRA', zone:'Centro', city:'Playa del Carmen', price:'$2,521,008 MXN', priceNote:'Hasta $8,130,420 MXN', area:'34.16 - 102.30 m²', status:'Preventa', image: IMG('1764173561_Artboard1.webp'), amenities:['Alberca','Coworking','Rooftop','Seguridad'], featured:true },
  { id:'macondo-corazon', name:'Macondo Corazón', zone:'5ta Avenida', city:'Playa del Carmen', price:'$3,891,175 MXN', priceNote:'Hasta $7,115,019 MXN', area:'37.47 - 125.49 m²', status:'Venta', image: IMG('1736367542_ROOF%20BAR%20SKY.jpg'), amenities:['Alberca Infinity','Gimnasio','Sky Bar','Coworking'], featured:true },
  { id:'alba', name:'Alba', zone:'Puerto Cancún', city:'Cancún', price:'$900,000 USD', area:'160.30 - 453.10 m²', status:'Venta', image: IMG('1739831295_IMG_8476-topaz.jpg'), amenities:['Club de Playa','Gimnasio','Solarium','Jacuzzi'] },
  { id:'alux-33', name:'Alux 33', zone:'Region 01', city:'Puerto Morelos', price:'$4,272,400 MXN', area:'48.48 m²', status:'Venta', image: IMG('1741718076_fachada.jpg'), amenities:['Seguridad','Jacuzzi','Lavandería','Elevador'] },
  { id:'amara', name:'Amara', zone:'Region 8', city:'Tulum', price:'$3,834,000 MXN', area:'78 - 136 m²', status:'Venta', image: IMG('1738098936_AMA_08_BAR_240531.jpg'), amenities:['Restaurante','Lavandería','Fire Pit','Jacuzzi'] },
  { id:'baga-rivera-2', name:'Bagá Rivera 2', zone:'5ta Avenida', city:'Playa del Carmen', price:'$2,850,767 MXN', area:'41 - 78 m²', status:'Venta', image: IMG('1738182822_FACHADA%2002.jpg'), amenities:['Sala','Gimnasio','Recepción','Elevador'] },
  { id:'baga-riviera-1', name:'Bagá Riviera Fase 1', zone:'5ta Avenida', city:'Playa del Carmen', price:'$220,000 USD', area:'45 - 91 m²', status:'Venta', image: IMG('1738177343_1.jpg'), amenities:['Spa','Estacionamiento','Elevador','Recepción'] },
  { id:'brisas-45', name:'Brisas 45', zone:'Xpu-Ha Beach', city:'Playa del Carmen', price:'$19,500,000 MXN', area:'', status:'Venta', image: IMG('1752603685_Artboard1.webp'), amenities:['Seguridad','Resort','Playa'] },
  { id:'carpe-diem', name:'Carpe Diem', zone:'Aldea Zamá', city:'Tulum', price:'$3,605,888 MXN', area:'65 - 151 m²', status:'Venta', image: IMG('1738191793_ACCESO%20PRINCIPAL.jpg'), amenities:['Spa','Terraza','Restaurante','Estacionamiento'] },
  { id:'casa-flamingos', name:'Casa Flamingos', zone:'Lagos del Sol', city:'Cancún', price:'$48,000,000 MXN', area:'', status:'Venta', image: IMG('1752614105_Artboard1.webp'), amenities:['Seguridad','Asadores','Luxury Villa'] },
  { id:'chaac', name:'Chaac', zone:'Región 8', city:'Tulum', price:'$2,598,000 MXN', area:'36 - 56 m²', status:'Reventa', image: IMG('1740431434_foto.jpg'), amenities:['Lavandería','Restaurante','Bar','Terraza'] },
  { id:'dalai-dk', name:'Dalai DK', zone:'La Veleta', city:'Tulum', price:'$178,118 USD', area:'45 - 110 m²', status:'Venta', image: IMG('1739229672_14.-%20Alberca%20arriba%20toma%202.jpg'), amenities:['Bar en Alberca','Terraza','Estacionamiento','Jacuzzi'] },
  { id:'elements-326', name:'Elements 326', zone:'Region 15', city:'Tulum', price:'$274,125 USD', area:'45 - 91 m²', status:'Venta', image: IMG('1740436597_foto%208.jpg'), amenities:['Cine','Jacuzzi','Fire Pit','Huerto'] },
  { id:'hama', name:'Hama', zone:'Av Mahahual', city:'Mahahual', price:'$3,436,400 MXN', area:'42 - 145 m²', status:'Venta', image: IMG('1738208493_01_FACHADA%20PRINCIPAL%20FINAL.jpg'), amenities:['Yoga','Local Comercial','Solarium','Restaurante'] },
  { id:'macondo-5ta-iii', name:'Macondo 5ta Fase III', zone:'5ta Avenida', city:'Playa del Carmen', price:'$3,477,600 MXN', area:'36 - 63 m²', status:'Venta', image: IMG('1738211652_963_Fachada_HQ%20(1).jpg'), amenities:['Gimnasio','Pádel','Restaurante','Recepción'] },
  { id:'macondo-mahahual', name:'Macondo Mahahual', zone:'Mahahual', city:'Mahahual', price:'$4,507,008 MXN', area:'37.08 - 92.34 m²', status:'Venta', image: IMG('1736361344_942_Aerea_Dpto_Low.jpg'), amenities:['Recepción','Club de Playa','Playa Privada','Lavandería'] },
  { id:'macondo-mayakoba', name:'Macondo Mayakoba', zone:'Ciudad Mayakoba', city:'Playa del Carmen', price:'$3,008,000 MXN', area:'40.49 - 221.96 m²', status:'Preventa', image: IMG('1758999883_Artboard1.webp'), amenities:['Juegos Infantiles','Gimnasio','Seguridad','Senderos'] },
  { id:'macondo-playacar', name:'Macondo Playacar', zone:'Playacar', city:'Playa del Carmen', price:'$5,716,480 MXN', area:'77.89 - 293.25 m²', status:'Venta', image: IMG('1738166241_942_Aerea_Dpto_Low.jpg'), amenities:['Pádel','Golf Cart','Juegos Infantiles','Seguridad'] },
  { id:'macondo-punta-esmeralda', name:'Macondo Punta Esmeralda', zone:'Punta Esmeralda', city:'Playa del Carmen', price:'$2,851,087 MXN', area:'22 - 48 m²', status:'Venta', image: IMG('1738772585_1.%20Fachada%201.1%20Jardineras.jpg'), amenities:['Garage','Bar','Asadores','Gimnasio'] },
  { id:'macondo-tulum', name:'Macondo Tulum', zone:'Aldea Zamá', city:'Tulum', price:'$3,259,403 MXN', area:'45 - 123.48 m²', status:'Venta', image: IMG('1738219373_08_VISTA%20CALLE.jpg'), amenities:['Gimnasio','Terraza Jardín','Recepción','Terraza'] },
  { id:'pink-riad', name:'Pink Riad', zone:'Aldea Zamá', city:'Tulum', price:'$6,980,000 MXN', area:'88 - 170 m²', status:'Venta', image: IMG('1738255268_v01_m03.jpg'), amenities:['Jacuzzi','Seguridad','Gimnasio','Elevador'] },
  { id:'puerta-kaan', name:'Puerta Kaan', zone:'Región 15', city:'Tulum', price:'$214,900 USD', area:'75 - 124 m²', status:'Venta', image: IMG('1738258089_09-Puerta%20kaan2.jpg'), amenities:['Jacuzzi','Restaurante','Garage','Seguridad'] },
  { id:'seremonia-habitat', name:'Seremonia Habitat', zone:'Selva Maya', city:'Tulum', price:'$281,000 USD', area:'225 m²', status:'Preventa', image: IMG('1746739280_Artboard1.webp'), amenities:['Seguridad','Playa Privada','Juegos Infantiles','Gimnasio'] },
  { id:'villa-pasha', name:'Villa Pasha', zone:'Xpu-Ha', city:'Playa del Carmen', price:'$1,100,000 USD', area:'', status:'Venta', image: IMG('1774637131_Artboard1.webp'), amenities:['Seguridad','Asadores','Luxury Villa'] },
  { id:'xibalba', name:'Xibalba', zone:'La Veleta', city:'Tulum', price:'$4,845,000 MXN', area:'38 - 78 m²', status:'Venta', image: IMG('1740428460_foto%205.jpg'), amenities:['Gimnasio'] },
  { id:'xunik', name:'Xunik', zone:'Tulum', city:'Tulum', price:'$1,694,437 MXN', area:'36.72 - 119.62 m²', status:'Venta', image: IMG('1739811407_DSC02910-Mejorado-NR.jpg'), amenities:['Seguridad','Asadores','Sala','Gimnasio'] },
  { id:'zatara', name:'Zatara', zone:'Región 8', city:'Tulum', price:'$249,900 USD', area:'81 - 131 m²', status:'Venta', image: IMG('1738620700_15.-Exteriores-Alberca-Toma-2.jpg'), amenities:['Gimnasio','Cine','Elevador','Mezzanine'] },
];

const CITIES = ['Todo','Tulum','Playa del Carmen','Puerto Morelos','Cancún','Mahahual'];
const TYPES = ['Todo','Venta','Preventa','Reventa'];
const PER_PAGE = 6;

const convertPriceNote = (noteStr, language) => {
  if (!noteStr) return noteStr;
  const prefix = language === 'es' ? 'Hasta' : 'Up to';
  if (noteStr.includes('USD')) {
    const cleaned = noteStr.replace(/[^0-9]/g, '');
    const usd = parseInt(cleaned);
    if (isNaN(usd)) return noteStr;
    const mxn = usd * MXN_TO_USD;
    return `${prefix} $${usd.toLocaleString('en-US')} USD · $${mxn.toLocaleString('es-MX')} MXN`;
  }
  if (noteStr.includes('MXN')) {
    const cleaned = noteStr.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    const num = parseFloat(cleaned);
    if (isNaN(num)) return language === 'en' ? noteStr.replace('Hasta', 'Up to') : noteStr;
    const usd = Math.round(num / MXN_TO_USD);
    return `${prefix} $${num.toLocaleString('es-MX')} MXN · ~$${usd.toLocaleString('en-US')} USD`;
  }
  return language === 'en' ? noteStr.replace('Hasta', 'Up to') : noteStr;
};

const STATUS_EN = { 'Todo': 'All', 'Venta': 'Sale', 'Preventa': 'Pre-sale', 'Reventa': 'Resale' };
const AMENITY_EN = { 'Gimnasio': 'Gym', 'Alberca': 'Pool', 'Albercas': 'Pools', '2 Albercas': '2 Pools', 'Alberca Infinity': 'Infinity Pool', 'Seguridad': 'Security', 'Estacionamiento': 'Parking', 'Elevador': 'Elevator', 'Lavandería': 'Laundry', 'Restaurante': 'Restaurant', 'Terraza': 'Terrace', 'Recepción': 'Reception', 'Sala': 'Lounge', 'Club de Playa': 'Beach Club', 'Playa': 'Beach', 'Frente al Mar': 'Beachfront', 'Fire Pit': 'Fire Pit', 'Jacuzzi': 'Jacuzzi', 'Solarium': 'Solarium', 'Spa': 'Spa', 'Sky Bar': 'Sky Bar', 'Coworking': 'Coworking', 'Rooftop': 'Rooftop' };

const translateStatus = (status, lang) => lang === 'en' ? (STATUS_EN[status] || status) : status;
const translateAmenity = (amenity, lang) => lang === 'en' ? (AMENITY_EN[amenity] || amenity) : amenity;

const PropertyCard = ({ p, language }) => (
  <div className="bg-[#FAFAF7]/5 backdrop-blur-md border border-[#FAFAF7]/10 overflow-hidden group hover:bg-[#FAFAF7]/10 transition-all duration-300 rounded-[20px]" style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.18)' }} data-testid={`property-${p.id}`}>
    <div className="relative h-52 overflow-hidden">
      <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
      <div className={`absolute top-4 left-4 px-3 py-1 text-xs font-medium rounded-full ${p.status === 'Preventa' ? 'bg-[#2BBFBF] text-[#0A2235]' : p.status === 'Reventa' ? 'bg-yellow-500 text-[#0A2235]' : 'bg-[#0A2235] text-[#2BBFBF]'}`}>
        {translateStatus(p.status, language)}
      </div>
    </div>
    <div className="p-5">
      <h3 className="font-playfair text-xl text-[#FAFAF7] mb-1">{p.name}</h3>
      <div className="flex items-center gap-1 text-[#2BBFBF] text-sm mb-3">
        <MapPin className="w-3.5 h-3.5" />
        <span className="font-inter">{p.zone} · {p.city}</span>
      </div>
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="font-playfair text-lg text-[#FAFAF7]">{language === 'es' ? 'Desde' : 'From'} {convertPrice(p.price, language)}</p>
          {p.priceNote && <p className="font-inter text-xs text-[#FAFAF7]/50">{convertPriceNote(p.priceNote, language)}</p>}
        </div>
        {p.area && (
          <div className="flex items-center gap-1 text-[#FAFAF7]/70 text-sm">
            <Maximize className="w-3.5 h-3.5" />
            <span className="font-inter">{p.area}</span>
          </div>
        )}
      </div>
      <div className="flex flex-wrap gap-1.5 mb-4">
        {p.amenities.slice(0, 3).map((a) => (
          <span key={a} className="bg-[#0A2235] px-2.5 py-1 text-[#D4EDE8] rounded-full text-xs font-inter">{translateAmenity(a, language)}</span>
        ))}
        {p.amenities.length > 3 && (
          <span className="bg-[#0A2235] px-2.5 py-1 text-[#FAFAF7]/50 rounded-full text-xs font-inter">+{p.amenities.length - 3}</span>
        )}
      </div>
      <a href={`${WHATSAPP_LINK}&text=Hola%2C%20me%20interesa%20${encodeURIComponent(p.name)}`} target="_blank" rel="noopener noreferrer">
        <Button variant="outline" className="w-full border-[#2BBFBF] text-[#2BBFBF] hover:bg-[#2BBFBF] hover:text-[#0A2235] rounded-full transition-all duration-300 group/btn" data-testid={`property-btn-${p.id}`}>
          {language === 'es' ? 'Solicitar información' : 'Request info'}
          <ArrowRight className="w-4 h-4 ml-2 group-hover/btn:translate-x-1 transition-transform" />
        </Button>
      </a>
    </div>
  </div>
);

export const FeaturedProperties = () => {
  const { language } = useLanguage();
  const [cityFilter, setCityFilter] = useState('Todo');
  const [typeFilter, setTypeFilter] = useState('Todo');
  const [currentPage, setCurrentPage] = useState(1);

  const featured = ALL_PROPERTIES.filter(p => p.featured);

  const filtered = useMemo(() => {
    return ALL_PROPERTIES.filter(p => {
      if (!p.featured) {
        if (cityFilter !== 'Todo' && p.city !== cityFilter) return false;
        if (typeFilter !== 'Todo' && p.status !== typeFilter) return false;
      }
      return !p.featured;
    });
  }, [cityFilter, typeFilter]);

  const totalPages = Math.ceil(filtered.length / PER_PAGE);
  const paginated = filtered.slice((currentPage - 1) * PER_PAGE, currentPage * PER_PAGE);

  const handleFilter = (type, value) => {
    if (type === 'city') setCityFilter(value);
    else setTypeFilter(value);
    setCurrentPage(1);
  };

  return (
    <section id="properties" data-testid="properties-section" className="bg-[#0A2235] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-16 lg:px-24">
        {/* Aurven-style centered heading */}
        <div className="text-center mb-16">
          <span className="inline-block font-inter text-xs uppercase tracking-[0.25em] text-[#FAFAF7]/40 border border-[#FAFAF7]/15 px-4 py-1.5 rounded-sm mb-8">
            {language === 'es' ? 'Propiedades disponibles' : 'Available Properties'}
          </span>
          <h2 className="font-playfair text-[clamp(2rem,5vw,4rem)] text-[#FAFAF7] leading-[1.08] tracking-tight" data-testid="properties-title">
            {language === 'es' ? (
              <>Tu propio rincón de <em className="text-[#2BBFBF]">paraíso</em> tropical</>
            ) : (
              <>Own your own corner of tropical <em className="text-[#2BBFBF]">paradise</em></>
            )}
          </h2>
          <p className="font-inter text-[#FAFAF7]/50 mt-6 max-w-2xl mx-auto leading-[1.7] text-sm">
            {language === 'es' ? 'Explora nuestra colección curada de propiedades de inversión, cada una diseñada para elegancia, confort y valor a largo plazo.' : 'Explore our handpicked collection of investment properties, each designed for elegance, comfort, and timeless value.'}
          </p>
        </div>

        {/* Featured 3 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {featured.map((p) => <PropertyCard key={p.id} p={p} language={language} />)}
        </div>

        {/* Divider + Filters */}
        <div className="border-t border-[#FAFAF7]/10 pt-12 mb-8">
          <h3 className="font-playfair text-2xl text-[#FAFAF7] mb-6">{language === 'es' ? 'Todos los proyectos' : 'All projects'}</h3>
          
          {/* City filter */}
          <div className="flex flex-wrap gap-2 mb-4" data-testid="city-filters">
            {CITIES.map(c => (
              <button key={c} onClick={() => handleFilter('city', c)}
                className={`px-4 py-2 text-sm font-inter rounded-full transition-all ${cityFilter === c ? 'bg-[#2BBFBF] text-[#0A2235] font-semibold' : 'bg-[#FAFAF7]/5 text-[#FAFAF7]/70 hover:bg-[#FAFAF7]/10'}`}
                data-testid={`filter-city-${c}`}>
                {c === 'Todo' && language === 'en' ? 'All' : c}
              </button>
            ))}
          </div>

          {/* Type filter */}
          <div className="flex flex-wrap gap-2 mb-8" data-testid="type-filters">
            {TYPES.map(t => (
              <button key={t} onClick={() => handleFilter('type', t)}
                className={`px-4 py-2 text-sm font-inter rounded-full transition-all ${typeFilter === t ? 'bg-[#2BBFBF] text-[#0A2235] font-semibold' : 'bg-[#FAFAF7]/5 text-[#FAFAF7]/70 hover:bg-[#FAFAF7]/10'}`}
                data-testid={`filter-type-${t}`}>
                {language === 'en' ? translateStatus(t, 'en') : t}
              </button>
            ))}
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {paginated.map((p) => <PropertyCard key={p.id} p={p} language={language} />)}
        </div>

        {/* Empty state */}
        {filtered.length === 0 && (
          <div className="text-center py-16">
            <p className="font-inter text-[#FAFAF7]/50 text-lg">{language === 'es' ? 'No hay propiedades con estos filtros.' : 'No properties match these filters.'}</p>
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-2 mt-12" data-testid="pagination">
            <button onClick={() => setCurrentPage(p => Math.max(1, p - 1))} disabled={currentPage === 1}
              className="w-10 h-10 rounded-full flex items-center justify-center bg-[#FAFAF7]/5 text-[#FAFAF7]/70 hover:bg-[#FAFAF7]/10 disabled:opacity-30 transition-all"
              data-testid="page-prev">
              <ChevronLeft className="w-5 h-5" />
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
              <button key={page} onClick={() => setCurrentPage(page)}
                className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-inter transition-all ${currentPage === page ? 'bg-[#2BBFBF] text-[#0A2235] font-bold' : 'bg-[#FAFAF7]/5 text-[#FAFAF7]/70 hover:bg-[#FAFAF7]/10'}`}
                data-testid={`page-${page}`}>
                {page}
              </button>
            ))}
            <button onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))} disabled={currentPage === totalPages}
              className="w-10 h-10 rounded-full flex items-center justify-center bg-[#FAFAF7]/5 text-[#FAFAF7]/70 hover:bg-[#FAFAF7]/10 disabled:opacity-30 transition-all"
              data-testid="page-next">
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        )}

        {/* Results count */}
        <p className="text-center font-inter text-[#FAFAF7]/40 text-sm mt-4">
          {language === 'es' ? `Mostrando ${paginated.length} de ${filtered.length} propiedades` : `Showing ${paginated.length} of ${filtered.length} properties`}
        </p>
      </div>
    </section>
  );
};
